<template>
  <section class="orederlist">
    <ul>
      <li v-for="(item, index) of list" :key="index" @click="getorder(item.orderType)" :class="actived == item.orderType ? 'selected' : ''">
        {{ item.name }}
      </li>
    </ul>
  </section>
</template>
<script>
import { orderType } from "@/utils/orderType"
export default {
  model: {
    prop: 'actived',
    event: 'tabActive'
  },
  props: [
    "actived"
  ],
  data () {
    return {
      list: [
        { name: '待付款', orderType: orderType('待付款').id },
        { name: '待发货', orderType: orderType('待发货').id },
        { name: '待收货', orderType: orderType('待收货').id },
        { name: '已完成', orderType: orderType('已完成').id },
        { name: '退换记录', orderType: orderType('售后').id }
      ]
    }
  },
  methods: {
    getorder (value) {
      this.$emit('tabActive', value || this.$route.query.typeId)
    }
  },
  created () {
    this.getorder()
  }
}
</script>
<style lang="scss" scoped>
.orederlist {
  font-size: 0.28rem;
  ul {
    padding: 0.1rem 0.2rem;
    display: flex;
    justify-content: space-between;
    background: #fff;
    li {
      margin: 0.2rem;
      padding-bottom: 0.1rem;
    }
  }
  .selected {
    border-bottom: 0.12rem solid #ff6161;
    color: #ff6161;
  }
}
</style>